// The backend prunes each admin Business Accounts row to `columns` (plus `id`), so every
// field a renderer reads must be requested explicitly, not only the visible column ids.

// Present whatever columns are visible: the fixed Status column, the Actions column
// (business_account.id for Settings/Delete/Comments, is_deletable for Delete) and the row
// handlers that navigate by user_id.
export const ALWAYS_REQUESTED_COLUMNS = [
  "id",
  "status",
  "user_id",
  "business_account",
  "is_deletable"
]

// Fields a visible column's render reads besides its own dataIndex (components/Table/columns.js).
export const COLUMN_DEPENDENCIES = {
  user_full_name: ["count_of_business_account"],
  alerts_count: ["demo_mode"],
  auto_refund_amount_other: ["enable_auto_refunds"],
  auto_cancel_amount: ["auto_cancel_subscriptions"]
}

export const getRequestedColumns = (activeColumnIds) =>
  [
    ...new Set([
      ...ALWAYS_REQUESTED_COLUMNS,
      ...activeColumnIds,
      ...activeColumnIds.flatMap((field_id) => COLUMN_DEPENDENCIES[field_id] || [])
    ])
  ].join(",")
